import { Events } from '@/state/app';
import { walletAtom } from '@/state/wallet';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useEvents } from './events';

export const usePolling = (isPageFocussed: boolean) => {
    const walletState = useRecoilValue(walletAtom);
    const { pushEvent } = useEvents();

    const POLLING_INTERVAL = 30_000;

    //Polling when valid metamask
    useEffect(() => {
        if (!walletState.selectedAddress) return;

        const pollTimer = setInterval(() => {
            pushEvent(Events.updateValuesEvent, Date.now());
        }, POLLING_INTERVAL);

        return () => {
            clearInterval(pollTimer);
        };
    }, [walletState.selectedAddress]);

    useEffect(() => {
        if (isPageFocussed) {
            pushEvent(Events.updateValuesEvent, Date.now());
        }
    }, [isPageFocussed]);
};
